<template>
  <div class="inlineList">
    <nuxt-link class="item" v-for="item in list" :key="item.id" :to="getPath(toPath, item)">
      <div class="title" v-html="item.contentTitle"></div>
      <time v-if="item.createTime">{{ dayjs(item.createTime).format("YYYY-MM-DD") }}</time>
    </nuxt-link>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
const Route = useRoute();

function getPath(propsPath, item) {
  if (propsPath) {
    return `${propsPath}${item.id}?from=${Route.path}`
  } else {
    return `${item.toPath}?from=/sousuo?query=${Route.query.query}&type=${Route.query.type?Route.query.type:''}&page=${Route.query.page?Route.query.page:1}`
  }
}

const props = defineProps({
  list: {
    required: true,
    type: Array
  },
  toPath: {
    // required: true,
    type: String,
  }
})
</script>

<style scoped lang="scss">
.inlineList {
  margin-top: 48px;
  margin-bottom: 60px;
  > .item {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #D8D8D8;
    line-height: 56px;
    text-decoration: none;
    margin-bottom: 28px;
    .title {
      color: var(--title-text-color);
    }
    time {
      color: var(--secondary-text-color);
    }
    &:hover {
      border-color: var(--main-blue-color);
      color: var(--main-blue-color);
      .title {
        color: var(--main-blue-color);
      }
      time {
        color: var(--main-blue-color);
      }
    }
  }
}
</style>